import React, { ComponentProps, useState } from 'react';
import { useNavigate } from 'react-router';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Icons } from '../../components/atoms/SVG';
import { ISonURL } from '../../types/IUrl';
import { SonForm } from '../../_lib/Form2';
import Btn from '../../components/molecules/Btn';
import { ButtonType } from '../../types/ButtonType';
import { AnyParameter } from '../../_lib/Form2/types/SonForm';
import ModalDialog from '../../components/organisms/ModalDialog/ModalDialog';
import { AcceptDeclineForm } from '../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { TooltipPlacement } from '../../components/atoms/Tooltip';
import { TimeControlledPublicationInfoText } from './partials/TimeControlledPublicationInfoText';
import { PagePublicationInfo } from '../../_lib/components/PagePublicationInfo/PagePublicationInfo';
import {
  PagePublicationInfoButtons,
} from '../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoButtons';

type AbortTriggeredPagePublish = {
  form: SonForm<AnyParameter>;
};

type TimeControlledPublication = {
  scheduledDate: string;
  parentPageInfos?: ISonURL;
  abortTriggeredPagePublish: AbortTriggeredPagePublish;
};

type PagePublicationInfoProps = {
  elementType: string;
  views: { default: { embedded: { timeControlledPublication?: TimeControlledPublication; proposedPublication: any } } };
};

function TimeControlledPublicationInfo(props: PagePublicationInfoProps) {
  const { t } = useSonTranslation('TimeControlledPublicationInfo');
  const navigate = useNavigate();
  const [showAbortModal, setShowAbortModal] = useState(false);

  const { timeControlledPublication } = props.views.default.embedded;

  return (
    <PagePublicationInfo headline={t('invisibleHeadline')}>
      <TimeControlledPublicationInfoText timeControlledPublication={timeControlledPublication} />
      <PagePublicationInfoButtons>
        {timeControlledPublication?.abortTriggeredPagePublish
          ? (
              <>
                <Btn
                  type={ButtonType.BUTTON}
                  text={t('abortRelease.buttonDescription')}
                  titleText={t('abortRelease.buttonDescription')}
                  tooltipPlacement={TooltipPlacement.TOP}
                  hiddenText
                  svgSpriteId={Icons.TIMEBOX_UNSET}
                  onClick={() => setShowAbortModal(true)}
                />
                {showAbortModal
                  ? (
                      <ModalDialog
                        closeModal={() => setShowAbortModal(false)}
                        headline={t('abortRelease.modalHeadline')}
                        initialFocusIndex={1}
                      >
                        <AcceptDeclineForm
                          messageSuccess={t('abortRelease.success')}
                          messageSending={t('abortRelease.sending')}
                          messageFail={t('abortRelease.fail')}
                          headline={t('abortRelease.headline')}
                          form={timeControlledPublication?.abortTriggeredPagePublish.form}
                          onSuccess={() => navigate(0)}
                        />
                      </ModalDialog>
                    )
                  : null}
              </>
            )
          : null}
      </PagePublicationInfoButtons>
    </PagePublicationInfo>
  );
}

export const TimeControlledPublicationInfoBlock = asFetchableBlock(
  TimeControlledPublicationInfo,
  BlockType.timecontrolledpublicationinfo,
);
export type TimeControlledPublicationInfoBlock = ComponentProps<typeof TimeControlledPublicationInfoBlock>;
